import { render, staticRenderFns } from "./ProductEditDefault.vue?vue&type=template&id=91a5209a"
import script from "./ProductEditDefault.vue?vue&type=script&lang=ts"
export * from "./ProductEditDefault.vue?vue&type=script&lang=ts"
import style0 from "./ProductEditDefault.vue?vue&type=style&index=0&id=91a5209a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91a5209a')) {
      api.createRecord('91a5209a', component.options)
    } else {
      api.reload('91a5209a', component.options)
    }
    module.hot.accept("./ProductEditDefault.vue?vue&type=template&id=91a5209a", function () {
      api.rerender('91a5209a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditDefault.vue"
export default component.exports